import { httpBus } from "@/api/index.js";

/**
 * 查看策略历史
 * @param {*} station_id
 * @param {*} elink_id
 * @param {*} page_num
 * @param {*} page_size
 * @returns
 */
export const getStrategyHistory = (station_id, elink_id, page_num, page_size) => {
  return httpBus.request("get", "/strategy/api/station/elink/strategy/log", {
    params: { station_id, elink_id, page_size, page_num }
  });
};

/**
 * 获取eLink 列表
 * @returns
 */
export function getElinkList(station_id, status) {
  return httpBus.request("get", `/strategy/api/station/elinks`, {
    params: {
      station_id,
      status
    }
  });
}

/**
 * 获取充放电计划
 * @returns
 */
export function getPlan(elink_id, begin_date, end_date) {
  return httpBus.request("get", `/strategy/api/station/elink/strategy`, {
    params: {
      elink_id,
      begin_date,
      end_date
    }
  });
}

/**
 * 功率跟踪
 * @param {*} stationId
 * @returns
 */
export function fetchPowerTrackingData(params) {
  return httpBus.request(
    "get",
    `/dashboard/dataAnalysis/powerTracking/querySocAndPower`,
    { params }
  );
}

/**
 * 第三方控制功率
 * @returns
 */
export function queryThirdPower(stationId, eLinkUUID, startTime, endTime) {
  return httpBus.request(
    "post",
    `/dashboard/dataAnalysis/powerTracking/queryThirdPower`,
    {
      data: {
        stationId: String(stationId),
        eLinkUUID,
        startTime,
        endTime
      }
    }
  );
}

/**
 * 根据电站ID获取所有elink和eblock的对应关系
 * @param {*} stationId
 * @returns
 */
export function getElinkStruct(stationId) {
  return httpBus.request("get", `/device/elink/eLinkList/${stationId}`);
}
